import React, { useState } from 'react';
import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import MyDevices from './MyDevices';
import AllDevices from './AllDevices';
import { User } from "../types";
import { API_BASE_URL } from '../config/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faGlobe
} from '@fortawesome/free-solid-svg-icons';

const subNavLinkClass = ({ isActive }: { isActive: boolean }) =>
  `nav-link${isActive ? ' active' : ''}`;

interface DeviceManagementProps {
  user: User;
}

const DeviceManagement: React.FC<DeviceManagementProps> = ({ user }) => {
  const [refreshMyDevices, setRefreshMyDevices] = useState<boolean>(false);

  const handleDeviceUpdate = () => {
    setRefreshMyDevices(prev => !prev);
  };

  const canInstallFirmware = ['admin', 'developer'].includes(user.role);

  return (
    <div className="container-fluid mt-3">
      <div className="row mb-3">
        <div className="col">
          <h3>Manage Devices</h3>
        </div>
      </div>

      <div className="mb-3">
        <ul className="nav nav-tabs nav-tabs-sm mb-3 flex-nowrap overflow-auto" style={{ borderBottom: '1px solid #dee2e6' }}>
          <li className="nav-item">
            <NavLink
              to="/devices"
              end
              className={subNavLinkClass}
              style={{ fontSize: '0.9rem', padding: '0.4rem 0.8rem' }}
            >
              <FontAwesomeIcon icon={faGlobe} className="me-1" />
              All Devices
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/devices/my-devices"
              className={subNavLinkClass}
              style={{ fontSize: '0.9rem', padding: '0.4rem 0.8rem' }}
            >
              <FontAwesomeIcon icon={faHome} className="me-1" />
              My Devices
            </NavLink>
          </li>
        </ul>
      </div>
      
      <div className="tab-content">
        <Routes>
          <Route
            index
            element={
              <AllDevices
                apiBaseUrl={API_BASE_URL}
                onDeviceUpdate={handleDeviceUpdate}
                canInstallFirmware={canInstallFirmware}
              />
            }
          />
          <Route
            path="my-devices"
            element={
              <MyDevices 
                apiBaseUrl={API_BASE_URL}
                canInstallFirmware={canInstallFirmware}
                key={`my-devices-${refreshMyDevices}`}
              />
            }
          />
          <Route path="dashboard" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/devices" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default DeviceManagement;
